import React from 'react';
import { useSpring, animated } from 'react-spring';

const Animation = ({props, children}) => {
  return (
    <animated.div style={useSpring(props.spring)}>
      {React.Children.map(children, child => {
        return React.cloneElement(child);
      })}
    </animated.div>
  );
}

export default Animation;
